import {
    TERMS_DETAILS
} from "../../constant/ActionType";

export default function TermsDetailsAlReducer(state = {
    termsdetailss: [],
    statusCode: null,
}, action) {
    switch (action.type) {
        case TERMS_DETAILS:
            return {
                ...state,
                termsdetailss: action.data,
                    statusCode: action.status
            };

        default:
    }
    return state;
}